import { PlanMealType } from './types';

const PLAN_STORAGE_KEY = 'mb:nutrition:plan';

export const loadPersistedPlan = (): PlanMealType[] => {
    try {
        const raw = sessionStorage.getItem(PLAN_STORAGE_KEY);

        return raw ? (JSON.parse(raw) as PlanMealType[]) : [];
    } catch {
        return [];
    }
};

export const persistPlan = (plan: PlanMealType[]): void => {
    try {
        sessionStorage.setItem(PLAN_STORAGE_KEY, JSON.stringify(plan));
    } catch {
        // storage unavailable (private mode / quota exceeded) — non-critical, plan stays in-memory
    }
};
